import { render, staticRenderFns } from "./OperChannel.vue?vue&type=template&id=56564f6a&"
import script from "./OperChannel.vue?vue&type=script&lang=js&"
export * from "./OperChannel.vue?vue&type=script&lang=js&"
import style0 from "./OperChannel.vue?vue&type=style&index=0&id=56564f6a&prod&lang=css&"
import style1 from "./OperChannel.vue?vue&type=style&index=1&id=56564f6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports